module.exports = __webpack_public_path__ + "img/about-title.5b9f27c7.png";